import { Dispatch, SetStateAction, createContext } from 'react'

export const SideBarContext = createContext<{
  setDrawerOpen: Dispatch<SetStateAction<boolean>>
  drawerOpen: boolean
} | null>(null)
